import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isDarkMode: false,
  customColors: {
  sidebar: "",
  header: "",
  activeButton: "",    
  activeTextColor: "",   
},
};

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.isDarkMode = !state.isDarkMode;
      if (state.isDarkMode) {
        state.customColors.sidebar = "";
        state.customColors.header = "";
      }
    },
     setCustomTheme: (state, action) => {
      state.customColors = {
        ...state.customColors,
        ...action.payload,
      };
    },
    resetCustomTheme: (state) => {
      state.customColors = { ...initialState.customColors };
    },
  },
});

export const { toggleTheme, setDarkMode, setCustomTheme, resetCustomTheme } =
  themeSlice.actions;

export default themeSlice.reducer;